module.exports = __webpack_public_path__ + "img/18.6c70eff6.jpg";